function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M447.8 64.2L64 64v384h384V64l-.2.2zM432 432H80V80h352v352z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M416 96H96v256h320V96zm-111.8 63.8c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zM153.5 336l70.7-100.5L295 336H153.5zm161.1.1l-25.9-36.9 22.3-31.6 48.2 68.5h-44.6z"
});

const SvgIosImage = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-image.3018f6c7.svg";
export { ForwardRef as ReactComponent };